import {useTranslation} from 'react-i18next';
import {useModalBtns} from '../../../../../../../../components/modal/use-modal-btns';
import {CompactModal} from '../../../../../../../../components/modal/compact-modal';
import {
  AddAttachmentsForm,
  SavingAttachment,
} from '../../../../../../../../components/daily-care-log/attachments/add-attachments-form';
import {useState} from 'react';
import {translations} from '../../../../../../../../i18n/translations';

export type SeniorAttachmentsCreateModalProps = {
  open: boolean;
  onClose: () => void;
  onSave: (savingAttachments: SavingAttachment[]) => Promise<void>;
};

export function SeniorAttachmentsCreateModal(props: SeniorAttachmentsCreateModalProps) {
  const {t} = useTranslation();
  const [files, setFiles] = useState<SavingAttachment[]>([]);
  const [valid, setValid] = useState<boolean>(true);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const actionButtons = useModalBtns({
    left: {
      type: 'cancel',
      onClick: props.onClose,
    },
    right: {
      type: 'save',
      onClick: async () => {
        try {
          setSubmitting(true);
          await props.onSave(files);
        } finally {
          setSubmitting(false);
        }
      },
      disabled: files.length === 0 || !valid,
      loading: submitting,
    },
  });

  return (
    <CompactModal
      open={props.open}
      onClose={props.onClose}
      title={t(translations.user_attachments.modals.create.title)}
      actions={actionButtons}
    >
      <AddAttachmentsForm
        type="upload"
        attachments={files}
        onAttachmentsChange={(attach) => {
          setFiles(attach);
        }}
        onError={(errors) => {
          if (errors.length > 0) {
            setValid(false);
          } else {
            setValid(true);
          }
        }}
      />
    </CompactModal>
  );
}
